<div class="recorder-container">
  <div class="boxContainer" *ngIf="recording">
    <div class="box box1"></div>
    <div class="box box2"></div>
    <div class="box box3"></div>
    <div class="box box4"></div>
  </div>
  <button mat-icon-button (click)="toggleRecording()" [class.is-recording]="recording">
    <svg class="svg" aria-hidden="true">
      <use ogSvgUnify="assets/sprite/sprite.svg#microphone-2"></use>
    </svg>
  </button>
</div>
